import React from 'react';
import { X } from 'lucide-react';

interface FormModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const FormModal: React.FC<FormModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div 
      className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[9999] flex items-center justify-center p-4 overflow-y-auto"
      onClick={onClose}
    >
      <div 
        className="bg-white rounded-lg shadow-xl relative
                   w-full max-w-[400px] sm:max-w-[450px] mx-auto my-auto
                   max-h-[85vh] sm:max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-3 top-3 sm:right-4 sm:top-4 text-gray-500 hover:text-gray-700 z-[10000] p-1"
        >
          <X className="h-5 w-5 sm:h-6 sm:w-6" />
        </button>
        
        <div className="p-3 sm:p-4 md:p-5">
          <h2 className="text-base sm:text-lg md:text-xl font-bold text-gray-900 mb-2 sm:mb-3 pr-6">
            Get Started
          </h2>
          <p className="text-gray-600 mb-3 sm:mb-4 text-xs sm:text-sm leading-relaxed">
            Fill out the form below and we'll get back to you shortly to discuss your automation needs.
          </p>
          
          <form
            action="https://formspree.io/f/movdgnvn"
            method="POST"
            className="space-y-2 sm:space-y-3"
          >
            <div>
              <label htmlFor="name" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                Full Name
              </label>
              <input
                type="text"
                id="name"
                name="name"
                required
                className="w-full px-2 py-1.5 sm:px-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-xs sm:text-sm"
                placeholder="John Smith"
              />
            </div>

            <div>
              <label htmlFor="email" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                Email Address
              </label>
              <input
                type="email"
                id="email"
                name="email"
                required
                className="w-full px-2 py-1.5 sm:px-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-xs sm:text-sm"
                placeholder="john@company.com"
              />
            </div>

            <div>
              <label htmlFor="company" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                Company Name
              </label>
              <input
                type="text"
                id="company"
                name="company"
                className="w-full px-2 py-1.5 sm:px-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-xs sm:text-sm"
                placeholder="Your Company Ltd."
              />
            </div>

            <div>
              <label htmlFor="service" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                Service Interest
              </label>
              <select
                id="service"
                name="service"
                className="w-full px-2 py-1.5 sm:px-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-xs sm:text-sm"
              >
                <option value="ai-consulting">AI Consulting</option>
                <option value="geo">GEO (Generative Engine Optimisation)</option>
                <option value="not-sure">Not Sure Yet</option>
              </select>
            </div>

            <div>
              <label htmlFor="message" className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                Your Message
              </label>
              <textarea
                id="message"
                name="message"
                rows={3}
                className="w-full px-2 py-1.5 sm:px-3 sm:py-2 border border-gray-300 rounded-md focus:ring-2 focus:ring-primary focus:border-primary text-xs sm:text-sm resize-none"
                placeholder="Tell us a bit about your automation needs..."
              ></textarea>
            </div>

            <button
              type="submit"
              className="w-full bg-primary text-white py-2 sm:py-2.5 px-3 sm:px-4 rounded-md hover:bg-primary-600 transition-colors text-xs sm:text-sm font-medium mt-3 sm:mt-4"
            >
              Send Message
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FormModal;